const DEEP_LINK_SCHEME = "mahalo";

const MOBILE_UA =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const IOS_UA = /iPhone|iPad|iPod/i;
const ANDROID_UA = /Android/i;

export function isMobileDevice(): boolean {
  return MOBILE_UA.test(navigator.userAgent);
}

export function isIOS(): boolean {
  return IOS_UA.test(navigator.userAgent);
}

export function isAndroid(): boolean {
  return ANDROID_UA.test(navigator.userAgent);
}

/**
 * Builds a deep link URL using the mahalo:// custom scheme.
 *
 * The path retains "mobile" as the host component since the Android app's
 * intent filter uses android:host="mobile".
 *
 * /mobile/survey?surveyId=abc   → mahalo://mobile/survey?surveyId=abc
 * /mobile/consent?consentId=abc → mahalo://mobile/consent?consentId=abc
 * /mobile/invitation            → mahalo://mobile/invitation?url=<origin>
 */
export function buildMahaloDeepLink(
  pathname: string,
  search: string,
): string {
  if (/^\/mobile\/invitation\/?$/i.test(pathname)) {
    const url = encodeURIComponent(window.location.origin);
    return `${DEEP_LINK_SCHEME}://mobile/invitation?url=${url}`;
  }

  const path = pathname.replace(/^\//, "");
  return `${DEEP_LINK_SCHEME}://${path}${search}`;
}
